module.exports = __webpack_public_path__ + "static/media/19.85f57a03.jpg";